
import { Box, Typography } from "@mui/material";
import { useStyles } from "../Common/CommonStyle";

export interface ISixMonthsLater {
  scenario5Stage1Finish: () => void;
}

export const SixMonthsLater = ({ scenario5Stage1Finish }: ISixMonthsLater) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
        background:
          "linear-gradient(107.56deg, #0C0D21 15.1%, rgba(12, 13, 33, 0) 82.81%)",
      }}
    >
      <>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "700",
            paddingLeft: "4rem",
            color: "#fff",
          }}
        >
          Six months later...
        </Typography>
        {scenario5Stage1Finish()}
      </>
    </Box>
  )
}